import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: string
    description?: ReactNode
    badge?: ReactNode
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    badge,
    className
}): ReactNode => {
    return (
        <div className={cn('max-w-2xl', className)}>
            <p className='inline-flex items-center gap-2.5 text-sm font-bold text-brand-700'>
                <span className='h-0.5 w-6 rounded-full bg-brand-400' aria-hidden='true' />
                {eyebrow}
            </p>

            <div className='mt-3 flex flex-wrap items-center gap-3'>
                <h2 id={id} className='text-3xl font-extrabold tracking-tight text-ink sm:text-4xl'>
                    {title}
                </h2>

                {badge}
            </div>

            {description && (
                <p className='mt-4 text-base leading-relaxed text-ink-soft sm:text-lg'>
                    {description}
                </p>
            )}
        </div>
    )
}
